import React, { useRef } from 'react'
// import mapvideo from "../../assets/video/GWR_SPANISH.mp4"
import mapvideo from "../../assets/images/GWR_SPANISH.gif"
import box7 from "../../assets/images/box7.png"

const Global = () => {
    // const activeClass = useFlickerEffect();
    const videoRef = useRef<HTMLVideoElement>(null);
    return (
        <>
            <section id='WarRooms' className={`relative z-40
            pb-10 sm:pb-20  lg:pb-[137.95px]  mt-[60px] md:mt-[120px]
            `}>
                <div className='max-w-[1200px] w-full mx-auto px-5'>
                    <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className='sm:text-[26px] text-[20px] sm:text-4xl md:text-[50px] text-white text-center font-gothicproMedium leading-[52px]  drop-shadow-custom '>    // GLOBAL WAR ROOMS</h2>
                    <div className='mt-5 md:mt-[45px] relative z-40 '>
                        <div className='max-w-[1060px] w-full' >
                            {/* <video className='w-full' ref={videoRef} src={mapvideo} autoPlay loop muted /> */}
                            <img className='w-full' src={mapvideo} alt="mapvideo" />
                        </div>
                        <div className='flex justify-end'>
                            <div className='relative max-w-[934px] w-full flex flex-col items-center' >
                                <img className='absolute w-full h-full bg-black/65' src={box7} alt="whiterborder" />
                                <div className='sm:pt-[41px] sm:px-10 sm:pb-[27px] p-6 ' >
                                    <p className='lg:text-[28px] md:text-[22px] text-base font-gothicproMedium text-white z-10 relative md:pb-6 pb-3' >Tu Protección, Nuestra Prioridad</p>
                                    <p className='font-inter leading-[140%] font-normal text-base sm:text-[21px] text-start text-[#C9C9C9] z-10 relative '>En el corazón de las operaciones de Armory hay tres War Rooms a nivel global ubicadas en Israel, México y en la UE. Usando el modelo “Follow The Sun”, aseguramos una protección alrededor del reloj; con hackers de élite pilotando los sistemas de Armory, probando y poniendo a prueba tus defensas implacablemente para estar a la vanguardia de las amenazas cibernéticas.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>)
}

export default Global
